import React, { useEffect, useState } from "react";
import Scrollbars from "react-custom-scrollbars-2";
import { Link, useLocation } from "react-router-dom";
import { SidebarData } from "../../shared/config/json/siderbar_data";
import HorizontalSidebar from "./horizontalSidebar";
import CollapsedSidebar from "./collapsedSidebar";
import { useSelector } from "react-redux";
import { hasUnreadUpdates } from "../../core/config/updatesNotification";
import { municipioPodeAcessarConvocacao } from "../../feature-module/convocacao/config/municipiosConvocacao";

const Sidebar = () => {
  const location = useLocation();
  const { perfilAtivo } = useSelector((state) => state.access);
  const { acessoAtivo } = useSelector((state) => state.access);

  const [subOpen, setSubopen] = useState("");
  const [subsidebar, setSubsidebar] = useState("");
  const [hasUnread, setHasUnread] = useState(false);

  useEffect(() => {
    const syncUnread = () => {
      setHasUnread(hasUnreadUpdates({ perfilAtivo, acessoAtivo }));
    };

    syncUnread();
    window.addEventListener("updates:seen-changed", syncUnread);
    window.addEventListener("storage", syncUnread);

    return () => {
      window.removeEventListener("updates:seen-changed", syncUnread);
      window.removeEventListener("storage", syncUnread);
    };
  }, [perfilAtivo, acessoAtivo]);

  const toggleSidebar = (title) => {
    setSubopen((prev) => (prev === title ? "" : title));
  };

  const toggleSubsidebar = (title) => {
    setSubsidebar((prev) => (prev === title ? "" : title));
  };

  const tipo = perfilAtivo?.tipo;
  const convocacaoDisponivel = municipioPodeAcessarConvocacao(acessoAtivo);
  const linksConvocacao = [
    "/convocacao-rastreamento",
    "/convocacao-seguimento",
  ];

  const renderMenuLabel = (title) => {
    const showBadge = title.link === "/atualizacoes" && hasUnread;

    return (
      <span
        className={`custom-active-span ${title.multiline ? "sidebar-label-multiline" : ""}`}
      >
        {title.label}
        {showBadge ? <span className="sidebar-update-badge">Novo</span> : null}
      </span>
    );
  };

  const permissoesPorTipo = {
    5: null, // ADMIN
    2: ["Principal", "Configuração de Acesso", "Relatórios", "Documentos"], // MUNICÍPIO
    3: ["Documentos"], // DRS
    6: ["Principal", "Pacientes", "Documentos"], // USUÁRIO
  };

  return (
    <div>
      <div className="sidebar" id="sidebar">
        <Scrollbars className="slimscroll">
          <div className="sidebar-inner slimscroll">
            <div id="sidebar-menu" className="sidebar-menu">
              <ul>
                {SidebarData.map((mainLabel) => {
                  const permissoes = permissoesPorTipo[tipo];

                  // Se não existir configuração → bloqueia tudo
                  if (!permissoes && tipo !== 5) return null;

                  // Se for ADMIN → libera tudo
                  if (tipo !== 5 && !permissoes.includes(mainLabel.label)) {
                    return null;
                  }

                  return (
                    <li className="submenu-open" key={mainLabel.label}>
                      <h6 className="submenu-hdr">{mainLabel.label}</h6>

                      <ul>
                        {mainLabel.submenuItems
                          ?.filter(
                            (title) =>
                              convocacaoDisponivel ||
                              !linksConvocacao.includes(title.link),
                          )
                          .map((title, i) => {
                          const links = [];

                          title?.submenuItems?.forEach((link) => {
                            links.push(link.link);
                            link?.submenuItems?.forEach((sub) =>
                              links.push(sub.link),
                            );
                          });

                          return (
                            <li
                              key={i}
                              className={`submenu ${
                                !title.submenu &&
                                location.pathname === title.link
                                  ? "custom-active-hassubroute-false"
                                  : ""
                              }`}
                            >
                              {title.external ? (
                                <a
                                  href={title.link}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  onClick={() => toggleSidebar(title.label)}
                                  className={`${
                                    subOpen === title.label ? "subdrop" : ""
                                  } ${
                                    links.includes(location.pathname)
                                      ? "active"
                                      : ""
                                  }`}
                                >
                                  {title.icon}
                                  {renderMenuLabel(title)}
                                  {title.submenu && (
                                    <span className="menu-arrow" />
                                  )}
                                </a>
                              ) : (
                                <Link
                                  to={title.link}
                                  onClick={() => toggleSidebar(title.label)}
                                  className={`${
                                    subOpen === title.label ? "subdrop" : ""
                                  } ${
                                    links.includes(location.pathname)
                                      ? "active"
                                      : ""
                                  }`}
                                >
                                  {title.icon}
                                  {renderMenuLabel(title)}
                                  {title.submenu && (
                                    <span className="menu-arrow" />
                                  )}
                                </Link>
                              )}

                              {title.submenu && (
                                <ul
                                  style={{
                                    display:
                                      subOpen === title.label
                                        ? "block"
                                        : "none",
                                  }}
                                >
                                  {title.submenuItems?.map((item, idx) => (
                                    <li
                                      className="submenu submenu-two"
                                      key={idx}
                                    >
                                      <Link
                                        to={item.link}
                                        className={`${
                                          subsidebar === item.label
                                            ? "subdrop"
                                            : ""
                                        } ${
                                          location.pathname === item.link
                                            ? "active"
                                            : ""
                                        }`}
                                        onClick={() =>
                                          toggleSubsidebar(item.label)
                                        }
                                      >
                                        {item.label}
                                        {item.submenu && (
                                          <span className="menu-arrow inside-submenu" />
                                        )}
                                      </Link>

                                      {item.submenu && (
                                        <ul
                                          style={{
                                            display:
                                              subsidebar === item.label
                                                ? "block"
                                                : "none",
                                          }}
                                        >
                                          {item.submenuItems?.map(
                                            (sub, sidx) => (
                                              <li key={sidx}>
                                                <Link
                                                  to={sub.link}
                                                  className={
                                                    location.pathname ===
                                                    sub.link
                                                      ? "active"
                                                      : ""
                                                  }
                                                >
                                                  {sub.label}
                                                </Link>
                                              </li>
                                            ),
                                          )}
                                        </ul>
                                      )}
                                    </li>
                                  ))}
                                </ul>
                              )}
                            </li>
                          );
                          })}
                      </ul>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        </Scrollbars>

        <div className="sidebar-footer">
          <div className="footer-version">
            <span className="footer-label version-text">v1.0.0</span>
          </div>
        </div>
      </div>

      <HorizontalSidebar />
      <CollapsedSidebar />
    </div>
  );
};

export default Sidebar;
